import { jsx } from 'react/jsx-runtime';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import PayPalButton from '../PayPalButton/PayPalButton.js';
import { usePaypalButtonState } from '../../../hooks/usePaypalButtonState.js';
import { useTracking } from '../../../hooks/useTracking.js';
import CoreProviders from '../../../providers/CoreProviders.js';
import { PaymentContextProvider, usePaymentContext } from '../../../providers/PaymentContextProvider.js';
import PayPalButtonContextProvider from '../../../providers/PayPalButtonContextProvider.js';
import PayPalPaymentService from '../../../services/PayPalPaymentService.js';

const PayPalCheckoutButtonWrapped = ({ amountMajorUnit, currency, locale, domain, track, }) => {
    const { initiatePayPalOptions, createOrder, onBuyNowButtonClicked, onError } = usePaypalButtonState({
        amountMajorUnit,
        currency,
        locale,
        track,
    });
    // Follow the styling and labelling logic from shop-checkout
    const buttonStyle = {
        color: 'gold',
        shape: 'pill',
        layout: 'vertical',
        disableMaxWidth: true,
        label: domain === 'zoohit.si' ? 'paypal' : 'buynow', //rewrite
    };
    return (jsx(PayPalScriptProvider, { options: initiatePayPalOptions, children: jsx(PayPalButton, { createOrder: createOrder, style: buttonStyle, onClick: onBuyNowButtonClicked, onError: onError }) }));
};
const PayPalCheckoutButton = () => {
    const { appConfig, checkoutState } = usePaymentContext();
    const { currency, paypalButton, customerId, customerType, sid } = checkoutState ?? {};
    const { paypalOrderAmount, paypalIdToken, onApprove, onCancel } = paypalButton ?? {};
    const { shop, locale, environment, realm } = appConfig ?? { locale: 'en-GB' };
    const { domain, siteId } = shop ?? { domain: 'zooplus.com' };
    const track = useTracking({
        currency,
        customerId,
        sid,
        siteId,
        guest: customerType === 'GUEST_CUSTOMER',
    });
    PayPalPaymentService.init(domain, locale);
    /**
     * The function to be called when the PayPal button "onApprove" callback is called.
     *
     * @param data The onApprove data
     */
    const onPayPalButtonApprove = async (data) => {
        if (onApprove && typeof onApprove === 'function') {
            onApprove(data.orderID);
        }
    };
    return (jsx(CoreProviders, { locale: locale, domain: domain, errorContainerId: '', env: environment, shopBundle: realm, featureName: "paypal", children: jsx(PayPalButtonContextProvider, { onApprove: onPayPalButtonApprove, onCancel: onCancel, userIdToken: paypalIdToken, children: jsx(PayPalCheckoutButtonWrapped, { track: track, amountMajorUnit: paypalOrderAmount ?? '', currency: currency ?? '', domain: domain, locale: locale }) }) }));
};
const PayPalModernizeCheckoutButton = ({ isDataMocked = false }) => {
    return (jsx(PaymentContextProvider, { isDataMocked: isDataMocked, children: jsx(PayPalCheckoutButton, {}) }));
};

export { PayPalModernizeCheckoutButton as default };
//# sourceMappingURL=PayPalModernizeCheckoutButton.js.map
